import React, { useState } from 'react';
import { Modal, Form, Input, Button, Switch, Tooltip } from 'antd';

const Model = ({
  title,
  open,
  onCancel,
  onFinish,
  label1,
  type1,
  name1,
  isRequired1,
  placeholder1,
  message1,
  label2,
  name2,
  isRequired2,
  placeholder2,
  message2,
  switchLabel,
  switchName,
  switchMessage,
  onSwitchChange,
  label3,
  name3,
  isRequired3,
  placeholder3,
  message3,
  type3,
  
}) => {
  const [form] = Form.useForm();
  const [isSwitchChecked, setIsSwitchChecked] = useState(false);

  const handleNumberInputChange = (e) => {
    const { value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, '');
    form.setFieldsValue({ [name2]: numericValue });
  };

  const handleFinish = (values) => {
    const cleanedValues = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [key, value || ""])
    );
    form.resetFields();
    onFinish(cleanedValues); 
  };

  const handleCancel = () => {
    form.resetFields(); 
    onCancel();
  };

  const handleSwitchChange = (checked) => {
    setIsSwitchChecked(checked);
    if (onSwitchChange) {
      onSwitchChange(checked);
    }
  };

  return (
    <Tooltip title="Changeable fields">
      <Modal title={title} visible={open} className='bg-white border border-colorSecondaryDark rounded-lg shadow-md shadow-colorSecondaryDark' footer={null} onCancel={handleCancel}>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={handleFinish}
          autoComplete="off"
        >
          {label1 && (
            <Form.Item
              label={label1}
              name={name1}
              type={type1}
              labelAlign='left'
              rules={[
                {
                  required: isRequired1,
                  message: isRequired1 ? message1 : '',
                },
              ]}
            >
              <Input placeholder={placeholder1} maxLength={100} />
            </Form.Item>
          )}

          {label2 && (
            <Form.Item
              label={label2}
              name={name2}
              labelAlign='left'
              rules={[
                {
                  required: isRequired2,
                  message: isRequired2 ? message2 : '',
                },
              ]}
            >
              <Input placeholder={placeholder2} maxLength={6} onChange={handleNumberInputChange} />
            </Form.Item>
          )}
           {label3 && (
            <Form.Item
              label={label3}
              name={name3}
              labelAlign='left'
              rules={[
                {
                  required: isRequired3,
                  message: isRequired3 ? message3 : '',
                },
              ]}
            >
              <Input placeholder={placeholder3} />
            </Form.Item>
          )}

          {switchLabel && (
            <Form.Item
              label={switchLabel}
              name={switchName}
              labelAlign='left'
              valuePropName="checked"
              rules={[
                {
                  required: true,
                  validator: (_, value) =>
                    value ? Promise.resolve() : Promise.reject(new Error(switchMessage)),
                },
              ]}
            >
              <Switch onChange={handleSwitchChange}
                className={isSwitchChecked ? '' : 'switch-false bg-[#ccc]'} />
            </Form.Item>
          )}

          <div>
            <Button className='text-white bg-colorSecondaryDark rounded-2xl py-1 px-4 block mx-auto' type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </Form>
      </Modal>
    </Tooltip>
  );
};

export default Model;
